import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["additionalGroup", "open", "close", "content"]

  connect() {
    console.log("additional-options connect")

    if (this.hasContentTarget) {
      this.checkContentVisibility()
    }
  }

  toggle() {
    this.additionalGroupTargets.forEach((group) => group.classList.toggle("hidden"))
    this.openTarget.classList.toggle("hidden")
    this.closeTarget.classList.toggle("hidden")
  }

  checkContentVisibility() {
    const isEmpty = this.contentTarget.innerText.trim() === ""
    this.element.classList.toggle("hidden", isEmpty)
  }
}
